import { Scale_Entity } from "../entities/scale";
import { TaskType_Entity } from "../entities/taskType";

const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base",
});

export function sortScalesByTaskType(
  scales: Scale_Entity[],
  taskTypes: { [key: number]: TaskType_Entity }
): Scale_Entity[] {
  return [...scales].sort((a, b) => {
    const aTaskType = taskTypes[a.taskTypeID];
    const bTaskType = taskTypes[b.taskTypeID];
    const aPos = aTaskType?.pos ?? Number.MAX_SAFE_INTEGER;
    const bPos = bTaskType?.pos ?? Number.MAX_SAFE_INTEGER;

    if (aPos !== bPos) return aPos - bPos;

    const nameSort = collator.compare(
      aTaskType?.name ?? "",
      bTaskType?.name ?? ""
    );
    if (nameSort !== 0) return nameSort;

    return a.id - b.id;
  });
}
